import { log } from 'log';
import { useCallback } from 'react';

import * as Types from '../types';

export const useOnConnect = ({
    setShowOverlay,
    runBrowserGeolocation,
    triggerGeolocation
}: {
    setShowOverlay: (showOverlay: boolean) => void;
    runBrowserGeolocation: () => Promise<GeolocationPosition>;
    triggerGeolocation: (options?: Types.ITriggerGeolocationOptions) => Promise<void>;
}) => {
    return useCallback(async () => {
        log('gcInfo', { event: 'connected' });

        try {
            const coordinates = await runBrowserGeolocation();

            await triggerGeolocation(coordinates?.coords);
        } catch (error: any) {
            log('gcErr', { error });

            if (error?.code === window.GeolocationPositionError?.PERMISSION_DENIED) {
                // player has not allowed geolocation
                setShowOverlay(false);
                return;
            }

            await triggerGeolocation();
        }
    }, [setShowOverlay, triggerGeolocation, runBrowserGeolocation]);
};
